import { useEffect, useRef } from 'react';

/**
 * Gets the value from the previous render of the observed variable.
 *
 * @param value - The variable to observe across renders.
 */
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
